import Pulse from '@sopranodesign/pulse-boost';

Pulse.render();
